import { getElementOrLogError } from '../../utils/utils';
export class BasketProduct {
    constructor(template, actions) {
        this.actions = actions;
        const content = getElementOrLogError('.basket__item', template.content);
        this.basketItem = content.cloneNode(true);
        this.indexElement = getElementOrLogError('.basket__item-index', this.basketItem);
        this.titleElement = getElementOrLogError('.card__title', this.basketItem);
        this.priceElement = getElementOrLogError('.card__price', this.basketItem);
        this.deleteButton = getElementOrLogError('.basket__item-delete', this.basketItem);
        this.removeButton();
    }
    removeButton() {
        var _a;
        if ((_a = this.actions) === null || _a === void 0 ? void 0 : _a.onClick) {
            this.deleteButton.addEventListener('click', this.actions.onClick);
        }
    }
    formatPrice(value) {
        return value === null ? 'Бесценно' : `${value} синапсов`;
    }
    render(data, index) {
        this.indexElement.textContent = String(index);
        this.titleElement.textContent = data.title;
        this.priceElement.textContent = this.formatPrice(data.price);
        return this.basketItem;
    }
}
